import { Download } from "@mui/icons-material";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import dayjs from "dayjs";
import React from "react";
import { AuthenticatedLink } from "../../../../components/custom/general/authenticatedLink/authenticatedLink";
import ContentNotFound from "../../../../components/mui/general/contentNotFound/contentNotFound";
import { API } from "../../../../helpers/constants";

const AttachmentsTable = ({ attachments = [], dateFormat, timeFormat, t }) => {
	return (
		<ContentNotFound displayContent={attachments.length > 0} message={t('No attachments found!')}>
			{attachments.map((file) => {
				return (
					<Box key={file.id}>
						<Stack direction={'row'} justifyContent={'space-between'}
							   width={'100%'} columnGap={0.4}>
							<Box>{file.OriginFileName}</Box>
							<Box>{file.LoginName}</Box>
							<Box>{dayjs(file.LastModifiedAt).format(`${dateFormat} ${timeFormat}`)}</Box>
							<Box>
								<AuthenticatedLink
									filename={file.OriginFileName}
									url={`${API}/en/attachments/issue/${file.id}`}
								>
									<Download fontSize="small" sx={{ cursor: 'pointer' }}/>
								</AuthenticatedLink>
							</Box>
						</Stack>
						<Divider/>
					</Box>
				)
			})}
		</ContentNotFound>
	);
};

export default AttachmentsTable